import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import HouseholdDocuments from "@/pages/agent/HouseholdDocuments";

export default function HelmDocuments() {
  const [households, setHouseholds] = useState([]);
  const [hid, setHid] = useState("");
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/agent/households");
      setHouseholds(data.households || []);
    })();
  }, []);

  return (
    <div className="p-6 sm:p-10 max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="font-display font-bold text-3xl lg:text-4xl text-[#0B192C] tracking-tight" data-testid="documents-title">Documents</h1>
        <p className="text-muted-foreground mt-1.5">Secure household files — scope of appointment, enrollment forms, ID cards, and more.</p>
      </div>
      <div className="rounded-xl border-2 border-[#E5E5E0] bg-white p-4 mb-5">
        <label className="text-xs font-semibold uppercase tracking-wide text-[#6B7280]">Household</label>
        <select value={hid} onChange={(e) => setHid(e.target.value)} className="mt-1 h-11 w-full rounded-md border bg-white px-2 text-sm" data-testid="documents-household-picker">
          <option value="">Select a household…</option>
          {households.map((h) => <option key={h.household_id} value={h.household_id}>{h.name}{h.state ? ` — ${h.state}` : ""}</option>)}
        </select>
      </div>
      {hid ? <HouseholdDocuments hid={hid} /> : (
        <div className="rounded-xl border-2 border-dashed border-[#E5E5E0] bg-white p-10 text-center text-[#6B7280]" data-testid="documents-pick-prompt">Pick a household to view and upload its documents.</div>
      )}
    </div>
  );
}
